<template>
  <div style="padding: 20px 40px 40px 40px;">
    <RecordsListener
      v-if="activateRecordsListener"
      collection="users"
      :userID="userJSON.id"
      :formID="formSelected"
      @records-real-time="getRecordsRealTime"
      @listener-is-destroyed="listenerIsDestroyed"
    />
    <div style="font-family: cerebriSansBold;">
      <div
        style="font-size: .625rem; color: #95aac9!important; text-transform: uppercase; letter-spacing: .08em;"
      >Forms</div>
      <div style="font-size: 1.625rem;">
        Visitor
        <b-button
          variant="primary"
          v-if="isVisitorForm && formSelected"
          @click="showNewRegistrationModal"
          style="float: right; font-family: cerebriSansReg; font-size: .9375rem; margin-left: 10px;"
        >Create Registration</b-button>
        <b-button
          variant="primary"
          v-if="isVisitorForm && formSelected"
          @click="readQR"
          style="float: right; font-family: cerebriSansReg; font-size: .9375rem; margin-left: 10px;"
        >Read QR Code</b-button>
      </div>
      <hr />
    </div>
    <!-- Content here -->
    <div style="font-family: cerebriSansReg;">
      <b-form-select v-model="formSelected" :options="optionsForms" @change="getFormHistory"></b-form-select>
    </div>
    <!-- Records Table -->
    <b-col lg="6" class="mt-3 mb-3" v-if="formSelected" style="float:right;">
      <b-form-group
        label="Filter"
        label-cols-sm="1"
        label-align-sm="right"
        label-size="sm"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-table
      hover
      :fields="recordsFields"
      :items="recordsRealTime"
      :filter="filter"
      @row-clicked="recordShow"
    ></b-table>

    <b-modal id="readQRModal" size="lg" hide-footer ref="readQRModalRef">
      <template v-slot:modal-title>Response QR</template>
      <div style="text-align: center;">
        <qrcode-stream @decode="onDecode"></qrcode-stream>
      </div>
    </b-modal>
    <b-modal id="registrationFromQR" hide-footer ref="registrationFromQRRef">
      <template v-slot:modal-title>Registration from QR</template>
      <div v-for="(input, index) in formToComplete.inputs" :key="index">
        <div v-if="input.visible == 'external'" style="margin-top: 20px;">
          <span style="font-weight: bold;">{{ input.title }}:</span>
          {{ input.value }}
        </div>
        <template v-if="input.visible == 'internal'">
          <template v-if="input.type == 'text'">
            <CustomFormGroup
              :label="input.title"
              :inputTag="index"
              @update-input="getTextInputData"
              style="margin-top: 20px;"
            />
          </template>
          <template v-if="input.type == 'boolean'">
            <div style="margin-top: 15px;">{{ input.title }}</div>
            <b-form-select
              v-model="formToComplete.inputs[index].value"
              :options="booleanOptions"
              @change="selectBool(index)"
            ></b-form-select>
          </template>
        </template>
      </div>
      <b-button
        v-if="everythingOK"
        @click="saveRegistration"
        variant="outline-info"
        style="float: right; margin-top: 15px;"
      >Check In</b-button>
    </b-modal>
    <b-modal id="showRecordModal" hide-footer ref="showRecordModalRef">
      <template v-slot:modal-title>Record</template>
      <div v-for="(input, index) in recordToModal.inputs" :key="index">
        <div style="margin-top: 20px;">
          <span style="font-weight: bold;">{{ input.title }}:</span>
          {{ input.value }}
        </div>
      </div>
      <div style="margin-top: 20px;">
        <span style="font-weight: bold;">Check In:</span>
        {{ recordToModal.checkIn }}
      </div>
      <div v-if="recordToModal.checkOut">
        <span style="font-weight: bold;">Check Out:</span>
        {{ recordToModal.checkOut }}
      </div>
      <b-button
        v-if="!recordToModal.checkOut"
        @click="checkOut"
        variant="outline-info"
        style="float: right;"
      >Check Out</b-button>
    </b-modal>
  </div>
</template>
<script>
// Components
import Header from "@/components/Header.vue";
import CustomFormGroup from "../../components/CustomFormGroup.vue";
import RecordsListener from "@/connection/RecordsListener.vue";
// External functions
import { functionsDB } from "@/connection/connection.js";
// Libraries
import Vue from "vue";
import VueSwal from "vue-swal";
import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueSwal);
Vue.use(VueQrcodeReader);

export default {
  name: "Guard",
  components: {
    Header,
    CustomFormGroup,
    RecordsListener
  },
  props: {
    userJSON: {}
  },
  data() {
    return {
      formSelected: null,
      optionsForms: [],
      isVisitorForm: true,
      allowedForms: [],
      formToComplete: {},
      everythingOK: false,
      recordsRealTime: [],
      activateRecordsListener: false,
      recordsFields: [],
      isListenerDestroyed: true,
      recordToModal: {},
      filter: "",
      booleanOptions: [
        { value: null, text: "Select your answer" },
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" }
      ]
    };
  },
  methods: {
    async checkOut() {
      var content = {
        checkOut: Date.now()
      };
      var isRecordUpdated = await functionsDB.updateRecord(
        "users",
        this.userJSON.id,
        this.recordToModal.rowID,
        content
      );
      if (isRecordUpdated) {
        this.$refs["showRecordModalRef"].hide();
        this.alertSuccess();
      } else {
        this.alertError();
      }
    },
    recordShow(event) {
      // Prepare data of the record to get redered in the modal
      this.recordToModal = event;
      this.recordToModal.inputs = [];
      var index = 0;
      var run = true;
      while (run) {
        if (event[`title_${index}`]) {
          this.recordToModal.inputs.push({
            title: event[`title_${index}`],
            value: event[`value_${index}`]
          });
        } else {
          run = false;
        }
        index++;
      }
      // console.log("modal", this.recordToModal);
      this.$refs["showRecordModalRef"].show();
    },
    getRecordsRealTime(recordsArray) {
      recordsArray.forEach((element, index) => {
        if (element.checkOut) {
          recordsArray[index].status = "Off-Site";
          recordsArray[index].checkOut = new Date(
            element.checkOut
          ).toLocaleString();
        } else {
          recordsArray[index].status = "On-Site";
        }
        recordsArray[index].checkIn = new Date(
          element.checkIn
        ).toLocaleString();
      });
      this.recordsRealTime = recordsArray;
      // console.log("records real time", this.recordsRealTime);
    },
    alertSuccess() {
      this.$swal({
        title: "Perfect!",
        text: "The operation was successful.",
        icon: "success"
      });
    },
    alertError() {
      this.$swal({
        title: "Something went wrong!",
        text: "Please try again",
        icon: "error"
      });
    },
    saveRegistration() {
      swal({
        title: "Are you sure?",
        text: "Once accepted, you will add a new record to the database.",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(async willAdd => {
        if (willAdd) {
          var newRecord = {};
          newRecord.id = this.formToComplete.id;
          newRecord.checkIn = Date.now();
          this.formToComplete.inputs.forEach((element, index) => {
            newRecord[`title_${index}`] = element.title;
            newRecord[`value_${index}`] = element.value;
          });
          var isRecordAdded = await functionsDB.writeNewRecord(
            "users",
            this.userJSON.id,
            newRecord
          );
          if (isRecordAdded) {
            this.$refs["registrationFromQRRef"].hide();
            this.alertSuccess();
          } else {
            this.alertError();
          }
        }
      });
    },
    selectBool(index) {
      if (this.formToComplete.inputs[index].value != null) {
        this.formToComplete.inputs[index].state = true;
      } else this.formToComplete.inputs[index].state = false;
      this.checkAllStates();
    },
    checkAllStates() {
      // checks all states to allow button
      var generalState = true;
      for (let index = 0; index < this.formToComplete.inputs.length; index++) {
        const element = this.formToComplete.inputs[index];
        if (element.visible == "internal") {
          if (!element.state) {
            generalState = false;
            break;
          }
        }
      }
      this.everythingOK = generalState;
    },
    getTextInputData(data) {
      this.formToComplete.inputs[data.index].value = data.value;
      this.formToComplete.inputs[data.index].state = data.state;
      this.checkAllStates();
    },

    onDecode(decodedString) {
      decodedString =
        '{"id":"u264uNxeXxZZTh2AtzHu","qr":[{"v":"Papa%20del%20perrito"},{"v":"al%20perrito"},{"v":"Traer%20un%20huesito"},{"v":"1"},{"v":"no"}]}';
      var objResponse = JSON.parse(decodedString);
      this.everythingOK = false;
      if (objResponse.id == this.formSelected) {
        var responseFormTemp;
        this.allowedForms.forEach(element => {
          if (objResponse.id == element.id) {
            responseFormTemp = element;
            var order = 0;
            responseFormTemp.inputs.forEach((element, index) => {
              if (element.visible == "external") {
                responseFormTemp.inputs[index].value = decodeURI(
                  objResponse.qr[order].v
                );
                order++;
              } else {
                if (element.type == "boolean") {
                  responseFormTemp.inputs[index].value = null;
                }
              }
            });
          }
        });
        this.formToComplete = responseFormTemp;
        this.$refs["readQRModalRef"].hide();
        this.$refs["registrationFromQRRef"].show();
      } else {
        this.$swal({
          title: "Something went wrong!",
          text: "QR does not belong to this form.",
          icon: "error"
        });
      }
    },
    async getFormHistory(id) {
      this.recordsFields = [];
      this.activateRecordsListener = false;
      // console.log(this.allowedForms);
      this.allowedForms.forEach(element => {
        if (element.id == id) {
          element.inputs.forEach((input, index) => {
            //prepare fields of the table
            if (input.inTable == true) {
              this.recordsFields.push({
                key: `value_${index}`,
                label: input.title
              });
            }
          });
        }
      });
      this.recordsFields.push({
        key: "checkIn",
        label: "Check-IN"
      });
      this.recordsFields.push({
        key: "checkOut",
        label: "Check-Out"
      });
      this.recordsFields.push({
        key: "status",
        label: "Status"
      });
      // console.log(this.recordsFields);
      const result = await this.waitForListenerDestroyed();
      clearInterval(this.dataChecker);

      this.activateRecordsListener = true;
      this.isListenerDestroyed = false;
    },
    listenerIsDestroyed() {
      this.isListenerDestroyed = true;
    },
    waitForListenerDestroyed() {
      var self = this;
      return new Promise(resolve => {
        self.dataChecker = setInterval(() => {
          if (self.isListenerDestroyed) {
            resolve("resolved");
          }
        }, 500);
      });
    },

    showNewRegistrationModal() {
      this.onDecode();
    },
    readQR() {
      this.$refs["readQRModalRef"].show();
    }
  },
  async mounted() {
    var self = this;
    // Start page code
    this.allowedForms = await functionsDB.getGuardForms(
      "users",
      this.userJSON.id
    );
    if (this.allowedForms) {
      this.optionsForms.push({ value: null, text: "Please select a form" });
      this.allowedForms.forEach((element, index) => {
        // preapre options of the select elemment
        this.optionsForms.push({
          value: element.id,
          text: element.name
        });
      });
    } else {
      this.alertError();
    }
  }
};
</script>